import { enableProdMode, ViewEncapsulation } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { Reboot } from './reboot';

declare var  __webpack_public_path__: string;

if (environment.production) {
  __webpack_public_path__ = '/dist/DesktopApp/';
  enableProdMode();
}

declare let PixiPlugin: any;

const init = () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(() => (<any>window).appBootstrap && (<any>window).appBootstrap())
    .catch(err => console.error('NG Bootstrap Error =>', err));
}

init();

// Init on reboot request
Reboot.getBootControl()
.watchReboot()
.subscribe({
  next: () => {
    init();
  },
});
